module.exports = __webpack_public_path__ + "static/img/5bg_8.7aaff81.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_8.png
// module id = 724
// module chunks = 1